import { VerticalContainer } from '@american-autonomy/ag-ui';

import StatItem from 'components/StatItem';

import useTranslation from 'pages/ApplicationDetailsPage/hooks/useTranslation';

import useDisplayValues from './hooks/useDisplayValues';

import {
    STAT_COVERAGE_AREA_TEST_ID,
    STAT_FLIGHT_TIME_TEST_ID,
    STAT_PASSES_TEST_ID,
    STAT_PRODUCTIVE_TEST_ID,
    STAT_TOTAL_DISTANCE_TEST_ID,
    STAT_TURNS_TEST_ID,
    TEST_ID,
    UNIT_ACRES,
    UNIT_MILES,
    UNIT_MIN,
    UNIT_PERCENT
} from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FlightPlannerStats: FunctionComponent<Props> = ({
    boundaryAreaHectares,
    className = '',
    speedMetersPerSecond,
    stats,
    testId = TEST_ID
}) => {
    const {
        COVERAGE_AREA,
        FLIGHT_TIME,
        PASSES,
        PLACEHOLDER_VALUE,
        PRODUCTIVE,
        TOTAL_DISTANCE,
        TURNS
    } = useTranslation();

    const { coverageArea, flightTime, passes, productive, totalDistance, turns } = useDisplayValues(
        {
            boundaryAreaHectares,
            placeholderValue: PLACEHOLDER_VALUE,
            speedMetersPerSecond,
            stats
        }
    );

    return (
        <VerticalContainer className={`${className} ${styles.flightPlannerStats}`} testId={testId}>
            <StatItem
                label={TOTAL_DISTANCE}
                testId={STAT_TOTAL_DISTANCE_TEST_ID}
                unit={UNIT_MILES}
                value={totalDistance}
            />

            <StatItem
                isHighlighted
                label={PRODUCTIVE}
                testId={STAT_PRODUCTIVE_TEST_ID}
                unit={UNIT_PERCENT}
                value={productive}
            />

            <StatItem label={PASSES} testId={STAT_PASSES_TEST_ID} value={passes} />

            <StatItem label={TURNS} testId={STAT_TURNS_TEST_ID} value={turns} />

            <StatItem
                label={FLIGHT_TIME}
                testId={STAT_FLIGHT_TIME_TEST_ID}
                unit={UNIT_MIN}
                value={flightTime}
            />

            <StatItem
                label={COVERAGE_AREA}
                testId={STAT_COVERAGE_AREA_TEST_ID}
                unit={UNIT_ACRES}
                value={coverageArea}
            />
        </VerticalContainer>
    );
};

export default FlightPlannerStats;
